const styles = (theme) => ({
  boxLevel: {
    border: `1px solid ${theme.palette.line.main}`,
    '&:nth-of-type(even)': {
      borderRight: '0px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: '9px',
    fontFamily: theme.typography.fontKanit,
  },
  color: {
    fontSize: '0.7rem',
    textAlign: 'center',
    fontFamily: theme.typography.fontKanit,
  },
  one: {
    background: '#db802b',
    constrastColor: '#000',
  },
  two: {
    background: '#ffc000',
    constrastColor: '#000',
  },
  three: {
    background: '#00b050',
    constrastColor: '#fff',
  },
  four: {
    color: '#fff',
    background: '#003cfa',
    constrastColor: '#fff',
  },
  five: {
    color: '#fff',
    background: '#ff0000',
    constrastColor: '#fff',
  },
});

export default styles;
